// Relations to center
export const REFERRAL_SOURCE_LABEL = 'Referral Source';
export const REFERRED_TO_LABEL = 'Referred To';
export const REPORTING_ORG_AGENCY_LABEL = 'Reporting Org/Agency';
export const AGENCY_SERVED_LABEL = 'Agency Served';
export const CLEARANCE_REQUIRED_LABEL = 'Clearance Required';
export const EDUCATION_PROVIDER_LABEL = 'Education Provider';
export const PARTNER_LABEL = 'Partner';
export const SPONSOR_LABEL = 'Sponsor';
export const ORGANIZER_LABEL = 'Organizer';
export const FUNDER_LABEL = 'Funder';

export const REFERRAL_SOURCE = {
    _id: '507f1f77bcf86cd799439011',
    label: REFERRAL_SOURCE_LABEL,
    description: 'Where participant heard about CMC services',
};
export const REFERRED_TO = {
    _id: '507f1f77bcf86cd799439012',
    label: REFERRED_TO_LABEL,
    description: 'Entity that CMC referred participant to',
};
export const REPORTING_ORG_AGENCY = {
    _id: '507f1f77bcf86cd799439013',
    label: REPORTING_ORG_AGENCY_LABEL,
    description: 'Entity that CMC reports activities to',
};
export const AGENCY_SERVED = {_id: '507f1f77bcf86cd799439014', label: AGENCY_SERVED_LABEL};
// export const CLEARANCE_REQUIRED = {_id: '507f1f77bcf86cd799439015', label: CLEARANCE_REQUIRED_LABEL};
export const EDUCATION_PROVIDER = {
    _id: '507f1f77bcf86cd799439016',
    label: EDUCATION_PROVIDER_LABEL,
    description: 'Entity that provides training, skills building, and other educational activities',
};
export const PARTNER = {_id: '507f1f77bcf86cd799439017', label: PARTNER_LABEL};
export const SPONSOR = {_id: '507f1f77bcf86cd799439018', label: SPONSOR_LABEL};
// export const ORGANIZER = {
//     _id: '507f1f77bcf86cd799439019',
//     label: ORGANIZER_LABEL,
//     description: 'Entity that organizes an event that the CMC participates in',
// };
export const FUNDER = {
    _id: '507f1f77bcf86cd799439020',
    label: FUNDER_LABEL,
    description: 'Entity that provides funds (grants, awards, etc)',
};

export const RELATIONSHIP_TO_CENTERS = [
    REFERRAL_SOURCE,
    REFERRED_TO,
    REPORTING_ORG_AGENCY,
    AGENCY_SERVED,
    // CLEARANCE_REQUIRED,
    EDUCATION_PROVIDER,
    SPONSOR,
    PARTNER,
    // ORGANIZER,
    FUNDER,
];
